"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGiftOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28 8h-6.26a3.27 3.27 0 00-.08-4.83A3.35 3.35 0 0019.24 2a3.57 3.57 0 00-2.55 1.26 4.88 4.88 0 00-.81 1.15 4.88 4.88 0 00-.81-1.15A3.55 3.55 0 0012.52 2a3.37 3.37 0 00-2.42 1.17A3.27 3.27 0 0010 8H4v7h2v13h20V15h2zm-9.87-3.35A1.78 1.78 0 0119.24 4a1.5 1.5 0 011 .56c.64.67.86 1.28-.09 2.25A5.27 5.27 0 0117 8a5.69 5.69 0 011.13-3.35zm-6.59-.09a1.5 1.5 0 011-.56 1.78 1.78 0 011.11.65A5.74 5.74 0 0114.76 8a5.24 5.24 0 01-3.13-1.15c-.94-1.01-.72-1.64-.09-2.29zM6 10h9v3H6zm2 5h7v11H8zm16 11h-7V15h7zm2-13h-9v-3h9z" })));
}
exports.default = SvgGiftOutline;
//# sourceMappingURL=GiftOutline.js.map